export default {
  state: {
    rooms: [],
    selectedRoomIds: [],
  },
  getters: {
    rooms: (state: any) => {
      return state.rooms;
    },
    selectedRooms: (state: any) => {
      const { rooms, selectedRoomIds } = state;
      return rooms.filter(({ roomId }) => selectedRoomIds.includes(roomId));
    },
    selectedRoom: (_state: any, getters: any) => {
      const { selectedRooms } = getters;
      return selectedRooms[0] || null;
    },
    selectedAllRooms: (state: any) => {
      const { rooms, selectedRoomIds } = state;
      return rooms.length === selectedRoomIds.length;
    },
  },
  mutations: {
    updateRooms: (state: any, value: any) => {
      state.rooms = value || [];
    },
    updateSelectedRoomIds: (state: any, value: any) => {
      state.selectedRoomIds = value || [];
    },
    resetSelectedRoomIds: (state: any) => {
      const { rooms } = state;
      state.selectedRoomIds = rooms.map(({ roomId }) => roomId);
    },
  },
};
